import Activiteit from "../modules/Activiteit/Activiteit";
import '../css/activiteitenStyling.css';
import { useActiviteiten } from "../utils/activiteiten";

const Activiteiten = () => {

    const act = useActiviteiten();

    const activiteiten = act.futureActiviteiten;
    const loadingMessage = act.loadingMessage;

    return (
        <div className="activiteitenContainer">
            <div className="activiteitenHeader">
                <h2>Activiteiten</h2>
                {loadingMessage && 
                <p>{loadingMessage}</p>
                }
            </div>
            
            <div className="activiteitenMain">
                {activiteiten && activiteiten.map(item => {
                        return  <Activiteit activiteit={item} key={item._id}/>
                })}
            </div>
        </ div>
    );
}

export default Activiteiten;